import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { 
	TableColumn, 
	DateTableColumn, 
	ButtonTableColumn, 
	IdentifierTableColumn, 
	MultiTableColumn,
	TableComponent, 
	DataReloadEvent, 
	LoginService, 
	TableElement, 
	BooleanComponent, 
	RadioComponent, 
	QuotaProgressTableColumn,
	SelectDialogComponent
} from '@serengeti/serengeti-common';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ProjectService } from '../service/project.service';

import { ChartOptions, ChartType } from 'chart.js';
import { Label, SingleDataSet } from 'ng2-charts';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

import { ProjectTopologyService } from '../service/topology.service';

@Component({
  selector: 'app-service-project-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ProjectListComponent implements OnInit {

	columns: TableColumn[];

	requestedColumns: TableColumn[];
	userWithdraw = new ButtonTableColumn('service.project.list.tabs.requested.content.columns.status.action.withdraw', 'Control', 'primary')
	.withChecker((element: any) => {
		if (element.status === 'Requested') {
			return true;
		} else {
			return false;
		}
	});
	userRemove = new ButtonTableColumn('service.project.list.tabs.requested.content.columns.status.action.remove', 'Control', 'primary')
	.withChecker((element: any) => {
		if (element.status === 'Approved') {
			return true;
		} else {
			return false;
		}
	});
	userApprove = new ButtonTableColumn('service.project.list.tabs.requested.content.columns.status.action.approve', 'Control', 'default')
	.withChecker((element: any) => {
		if (element.status === 'Pending') {
			return true;
		} else {
			return false;
		}
	});
	userReject = new ButtonTableColumn('service.project.list.tabs.requested.content.columns.status.action.reject', 'Control', 'primary')
	.withChecker((element: any) => {
		if (element.status === 'Pending') {
			return true;
		} else {
			return false;
		}
	});
	
	_searchControl: ElementRef;
	@ViewChild('search', { static: false }) set searchControl(_searchControl: ElementRef) {
		this._searchControl = _searchControl;
		if (_searchControl) {
			_searchControl.nativeElement.addEventListener('keypress', (e: KeyboardEvent) => {
				if (e.key === "Enter") {
					this.doSearch();
				}
		 	});
		}
	}
	get searchControl(): ElementRef {
		return this._searchControl;
	}
	
	oldSearchName: string;

	projects: any[];
	projectTotalElements = 0;
	_projectList: TableComponent;
	@ViewChild('projectList', {static: false}) set projectList(_projectList: TableComponent) {
		this._projectList = _projectList;

		this.doRefreshProjects();
	}

	get projectList(): TableComponent {
		return this._projectList;
	}

	_requestedList: TableComponent;
	@ViewChild('requestedList', {static: false}) set requestedList(_requestedList: TableComponent) {
		this._requestedList = _requestedList;

		this.doRefreshWaiting(new DataReloadEvent('createdDate', 'desc', 0, 10));
	}

	get requestedList(): TableComponent {
		return this._requestedList;
	}


	currentCondition: DataReloadEvent;
	searchName: string;

	currentWaitingCondition: DataReloadEvent;
	currentActivityCondition: DataReloadEvent;
	activityColumns: TableColumn[];
	searchActivityProject: string;

	_activityList: TableComponent;
	@ViewChild('activityList', {static: false}) set activityList(_activityList: TableComponent) {
		this._activityList = _activityList;

		this.doRefreshActivity(new DataReloadEvent('issuedDate', 'desc', 0, 15, this.searchActivityProject));
	}
	get activityList(): TableComponent {
		return this._activityList;
	}

	selectedIndex = 0;

	_topology: ElementRef;
	@ViewChild('topology', {static: false}) set topology(_topology: ElementRef) {
		this._topology = _topology;
	}
	get topology(): ElementRef {
	  return this._topology;
	}
  
	quotas: any;
	pieChartOptions: ChartOptions = {
		responsive: true,
		legend: {
		  position: 'bottom'
		}
	};
	pieChartData: any[];
	pieChartType: ChartType = 'pie';
	pieChartLegend = true;
	pieChartPlugins = [];

	constructor(
		private router: Router,
    	private dialog: MatDialog,
		private projectService: ProjectService,
		private translateService: TranslateService,
		private loginService: LoginService,
		private topologyService: ProjectTopologyService
	) {

		this.columns = [
			new TableColumn('name', 'service.project.list.content.columns.name'),
			new TableColumn('owner.name', 'service.project.list.content.columns.owner-name'),
			new TableColumn('userCount', 'service.project.list.content.columns.user-count')
			.withStyles('cellRight')
			.withIgnoreSort(true),
			new TableColumn('state', 'service.project.list.content.columns.state')
			.withStyles('cellCenter')
			.withDecorator((self: TableColumn, element: TableElement) => {
				const state = TableColumn._getData(element.getData(), self.column);
				if(state === 'Active') {
					return 'True';
				} else {
					return 'False';
				}
			}).withType(BooleanComponent),
			new TableColumn('quotas.QuotaCpu.used', 'service.project.list.content.columns.quota-cpu')
			.withStyles('cellRight')
			.withIgnoreSort(true)
			.withDecorator((self: TableColumn, element: TableElement) => {
				const value = TableColumn._getData(element.getData(), self.column);
				if (typeof value === 'undefined') {
					return new Number(0).toFixed(2);
				} else {
					return parseInt(value).toFixed(2);
				}
			}),
			new TableColumn('quotas.QuotaMemory.used', 'service.project.list.content.columns.quota-memory')
			.withStyles('cellRight')
			.withIgnoreSort(true)
			.withDecorator((self: TableColumn, element: TableElement) => {
				const value = TableColumn._getData(element.getData(), self.column);
				if (typeof value === 'undefined') {
					return new Number(0).toFixed(2);
				} else {
					return parseInt(value).toFixed(2);
				}
			}),
			new TableColumn('quotas.QuotaDisk.used', 'service.project.list.content.columns.quota-disk')
			.withStyles('cellRight')
			.withIgnoreSort(true)
			.withDecorator((self: TableColumn, element: TableElement) => {
				const value = TableColumn._getData(element.getData(), self.column);
				if (typeof value === 'undefined') {
					return new Number(0).toFixed(2);
				} else {
					return parseInt(value).toFixed(2);
				}
			}),
			new QuotaProgressTableColumn('quotas.QuotaCpu.total', 'quotas.QuotaCpu.used', 'service.project.list.content.columns.usage-cpu'),
			new QuotaProgressTableColumn('quotas.QuotaMemory.total', 'quotas.QuotaMemory.used', 'service.project.list.content.columns.usage-memory'),
			new QuotaProgressTableColumn('quotas.QuotaDisk.total', 'quotas.QuotaDisk.used', 'service.project.list.content.columns.usage-disk')
		];

		this.requestedColumns = [
			new TableColumn('container.name', 'service.project.list.tabs.requested.content.columns.name'),
			new TableColumn('container.owner.name', 'service.project.list.tabs.requested.content.columns.owner-name'),
			new MultiTableColumn([
				new TableColumn('status', 'service.project.list.tabs.requested.content.columns.status')
				  .withDecorator((self: TableColumn, element: TableElement) => {
					return 'service.project.list.tabs.requested.content.columns.status.state.' + element.getData().status;
				  }),
				this.userWithdraw,
				this.userRemove,
				this.userApprove,
				this.userReject,
			  ], 'service.project.detail.tabs.user.content.columns.status.title').withStyles('cellCenter'),
		];

		this.activityColumns = [
			new DateTableColumn('issuedDate', 'service.project.list.tabs.activity.content.columns.issued-date'),
			new TableColumn('user.name', 'service.project.list.tabs.activity.content.columns.triggered-user'),
			new TableColumn('container.name', 'service.project.list.tabs.activity.content.columns.issued-project'),
			new TableColumn('status', 'service.project.list.tabs.activity.content.columns.request-status'),
			new TableColumn('issuer.name', 'service.project.list.tabs.activity.content.columns.issued-user'),
			new TableColumn('changedStatus', 'service.project.list.tabs.activity.content.columns.issued-status'),
			new TableColumn('description', 'service.project.list.tabs.activity.content.columns.description')
		];

		this.selectedIndex = this.loginService.getScreenConfig('project.list', 'tabIndex', 0);
		this.projectService.user(this.loginService.getLoginId()).subscribe((serviceUser: any) => {
			this.quotas = (serviceUser.tenant ? serviceUser.tenant.quotas : null);
			
			if (this.quotas) {
				this.translateService.get([
					'setting.user.detail.tabs.quota.content.chart.quotacpu.legend.used',
					'setting.user.detail.tabs.quota.content.chart.quotacpu.legend.free',
					'setting.user.detail.tabs.quota.content.chart.quotamemory.legend.used',
					'setting.user.detail.tabs.quota.content.chart.quotamemory.legend.free',
					'setting.user.detail.tabs.quota.content.chart.quotadisk.legend.used',
					'setting.user.detail.tabs.quota.content.chart.quotadisk.legend.free',
					'setting.user.detail.tabs.quota.content.chart.quotagpu.legend.used',
					'setting.user.detail.tabs.quota.content.chart.quotagpu.legend.free',
					'setting.user.detail.tabs.quota.content.chart.quotamoneypermonth.legend.used',
					'setting.user.detail.tabs.quota.content.chart.quotamoneypermonth.legend.free'
				]).subscribe((messages: any) => {
					this.pieChartData = [];

					for (const displayQuota of environment.content.displayQuotas) {
						const quota = this._getQuota(this.quotas, displayQuota.type);

						if (quota) {
							const pieChart = {
								id: quota.type,
								labels: [] as Label[],
								data: [
								] as SingleDataSet
							};
							const used = quota.used.toFixed(2);
							const remaining = (quota.total - quota.used).toFixed(2);

							pieChart.data = [ used,  remaining ];
							pieChart.labels = [ 
								messages['setting.user.detail.tabs.quota.content.chart.' + quota.type.toLowerCase() + '.legend.used'],
								messages['setting.user.detail.tabs.quota.content.chart.' + quota.type.toLowerCase() + '.legend.free']
							] as Label[];
							this.pieChartData.push(pieChart);	
						}
					}
				});
			}
		});
	}

	_getQuota(quotas: any[], quotaType: string) {
		for (const quota of quotas) {
			if (quota.type === quotaType) {
				return quota;
			}
		}
		return null;
	}

	ngOnInit() {
		this.doSearch();
	}

	onTabChanged() {
		this.loginService.setScreenConfig('project.list', 'tabIndex', this.selectedIndex);
	}

	doRefreshTopology() {
		if (this.projects) {
			this.topologyService.build(this.topology, this.projects, true);
		}
	}

	doSearch() {
		if (this.oldSearchName && this.oldSearchName === this.searchName) {
			return;
		} else {
			const sortItem = this.loginService.getScreenConfig('project.list', 'sortItem');
			const sortOrder = this.loginService.getScreenConfig('project.list', 'sortOrder');
	
			this.oldSearchName = this.searchName;
			this.doRefresh(new DataReloadEvent((sortItem ? sortItem : 'name'), (sortOrder ? sortOrder : 'desc'),
				0, 10, this.searchName));	
		}
	}

	doSearchActivity() {
		const sortItem = this.loginService.getScreenConfig('project.list.activity', 'sortItem');
		const sortOrder = this.loginService.getScreenConfig('project.list.activity', 'sortOrder');

		this.doRefresh(new DataReloadEvent((sortItem ? sortItem : 'issuedDate'), (sortOrder ? sortOrder : 'desc'),
			0, 15, this.searchActivityProject));
	}

	doRefresh(condition?: DataReloadEvent) {
		if (condition) {
			this.currentCondition = condition;
		} else {
			condition = this.currentCondition;
		}

		if (condition.pageNumber === 0) {
			this.loginService.setScreenConfig('project.list', 'sortItem', condition.active);
			this.loginService.setScreenConfig('project.list', 'sortOrder', condition.sortOrder);
		}

		this.projectService.search(condition.filter, condition.active, condition.sortOrder, condition.pageNumber, condition.pageSize)
			.subscribe(resultPage => {
			this.projects = resultPage.content;
			this.projectTotalElements = resultPage.totalElements;

			this.doRefreshProjects();
			this.doRefreshWaiting();
			this.doRefreshTopology();
		});
	}

	doRefreshProjects() {
		if (this.projectList && this.projects) {
			this.projectList.refresh(this.projectTotalElements, this.projects, this.columns, this.currentCondition);
		}
	}

	doRequestProjectJoin() {
		const projectDialogRef = this.dialog.open(SelectDialogComponent, {
			width: '1000px',
			height: '800px',
			data: {
				title: 'service.project.list.dialog.select-project.title',
				query: environment.serviceProjectEndPoint + 'service/?dedicated=false&activeStates=Active&excludeUsers=' + encodeURIComponent(this.loginService.getLoginId()),
				method: 'page',
				columns: [
					new IdentifierTableColumn('id', 'service.project.list.dialog.select-project.columns.id', false).withType(RadioComponent),
					new TableColumn('name', 'service.project.list.dialog.select-project.columns.name'),
					new TableColumn('owner.name', 'service.project.list.dialog.select-project.columns.owner')
					.withIgnoreSort(true)
				],
				sortBy: "name"
			}
		});

		projectDialogRef.afterClosed().subscribe(returnValue => {
			if (returnValue && returnValue.result === true) {
				const project = returnValue.data[0].element;
				this.translateService.get(['service.project.list.dialog.select-project.confirm.request',
				'service.project.list.dialog.select-project.alert.requested',
				'service.project.list.dialog.select-project.alert.request-duplicated',
				'service.project.list.dialog.select-project.alert.request-failed']).subscribe((messages: any) => {
					if (confirm(messages['service.project.list.dialog.select-project.confirm.request'])) {
						this.projectService.request(project.id, this.loginService.getLoginId()).subscribe(() => {
							alert(messages['service.project.list.dialog.select-project.alert.requested']);
							this.doRefreshWaiting();
						}, (error: any) => {
							if (error.status === 417) {
								alert(messages['service.project.list.dialog.select-project.alert.request-duplicated']);
							} else {
								alert(messages['service.project.list.dialog.select-project.alert.request-failed']);
							}
						});
					}
				});
			}
		});
	}

	doRefreshWaiting(condition?: DataReloadEvent) {
		if (condition) {
			this.currentWaitingCondition = condition;
		} else {
			condition = this.currentWaitingCondition;
		}

		if (condition.pageNumber === 0) {
			this.loginService.setScreenConfig('project.list.waiting', 'sortItem', condition.active);
			this.loginService.setScreenConfig('project.list.waiting', 'sortOrder', condition.sortOrder);
		}

		this.projectService.waiting(condition.active, condition.sortOrder, condition.pageNumber, condition.pageSize)
			.subscribe(resultPage => {
			this.requestedList.refresh(resultPage.totalElements, resultPage.content, this.requestedColumns, condition);
		});

		if (this.activityList) {
			this.doRefreshActivity(new DataReloadEvent('issuedDate', 'desc', 0, 15, this.searchActivityProject));
		}
	}

	onHandleButtonClick($event: { column: { caption: string; }, element: any; }) {
		if ($event.column === this.userApprove) {
			this.translateService.get([
				'service.project.list.tabs.requested.confirm.approve',
				'service.project.list.tabs.requested.alert.approved',
				'service.project.list.tabs.requested.alert.approve-invalid-user',
				'service.project.list.tabs.requested.alert.approve-failed'
			]).subscribe((messages: any) => {
				const projectUser = $event.element.getData();

				if (confirm(messages['service.project.list.tabs.requested.confirm.approve'])) {
					this.projectService.approve(projectUser.container.id, projectUser.user.userId).subscribe(() => {
						alert(messages['service.project.list.tabs.requested.alert.approved']);
						this.doRefresh();
					}, (error: any) => {
						if (error.status === 417) {
							alert(messages['service.project.list.tabs.requested.alert.approve-invalid-member']);
						} else {
							alert(messages['service.project.list.tabs.requested.alert.approve-failed']);
						}
					});
				}
			});
		} else if ($event.column === this.userReject) {
			this.translateService.get([
				'service.project.list.tabs.requested.confirm.reject',
				'service.project.list.tabs.requested.alert.rejected',
				'service.project.list.tabs.requested.alert.reject-invalid-user',
				'service.project.list.tabs.requested.alert.reject-failed'
			]).subscribe((messages: any) => {
				const projectUser = $event.element.getData();

				if (confirm(messages['service.project.list.tabs.requested.confirm.reject'])) {
					this.projectService.reject(projectUser.container.id, projectUser.user.userId).subscribe(() => {
						alert(messages['service.project.list.tabs.requested.alert.rejected']);
					}, (error: any) => {
						if (error.status === 417) {
							alert(messages['service.project.list.tabs.requested.alert.reject-invalid-member']);
						} else {
							alert(messages['service.project.list.tabs.requested.alert.reject-failed']);
						}
					});
				}
			});
		} else if ($event.column === this.userRemove) {
			this.translateService.get([
				'service.project.list.tabs.requested.confirm.remove',
				'service.project.list.tabs.requested.alert.removed',
				'service.project.list.tabs.requested.alert.remove-invalid-user',
				'service.project.list.tabs.requested.alert.remove-failed'
			]).subscribe((messages: any) => {
				const projectUser = $event.element.getData();

				if (confirm(messages['service.project.list.tabs.requested.confirm.remove'])) {
					this.projectService.remove(projectUser.container.id, projectUser.user.userId).subscribe(() => {
						alert(messages['service.project.list.tabs.requested.alert.removed']);
						this.doRefresh();
					}, (error: any) => {
						if (error.status === 417) {
							alert(messages['service.project.list.tabs.requested.alert.remove-invalid-member']);
						} else {
							alert(messages['service.project.list.tabs.requested.alert.remove-failed']);
						}
					});
				}
			});
		} else if ($event.column === this.userWithdraw) {
			this.translateService.get([
				'service.project.list.tabs.requested.confirm.withdraw',
				'service.project.list.tabs.requested.alert.withdrawed',
				'service.project.list.tabs.requested.alert.withdraw-invalid-user',
				'service.project.list.tabs.requested.alert.withdraw-failed'
			]).subscribe((messages: any) => {
				const projectUser = $event.element.getData();

				if (confirm(messages['service.project.list.tabs.requested.confirm.withdraw'])) {
					this.projectService.withdraw(projectUser.container.id, projectUser.user.userId).subscribe(() => {
						alert(messages['service.project.list.tabs.requested.alert.withdrawed']);
						this.doRefreshWaiting();
					}, (error: any) => {
						if (error.status === 417) {
							alert(messages['service.project.list.tabs.requested.alert.withdraw-invalid-member']);
						} else {
							alert(messages['service.project.list.tabs.requested.alert.withdraw-failed']);
						}
					});
				}
			});
		}
	}

	doRefreshActivity(condition?: DataReloadEvent) {
		if (condition) {
			this.currentActivityCondition = condition;
		} else {
			condition = this.currentActivityCondition;
		}

		if (condition.pageNumber === 0) {
			this.loginService.setScreenConfig('project.list.activity', 'sortItem', condition.active);
			this.loginService.setScreenConfig('project.list.activity', 'sortOrder', condition.sortOrder);
		}

		this.projectService.activity(condition.filter, condition.active, condition.sortOrder, condition.pageNumber, condition.pageSize)
			.subscribe(resultPage => {
			this.activityList.refresh(resultPage.totalElements, resultPage.content, this.activityColumns, condition);
		});
	}

	goCreate() {
		this.router.navigate(['/main', { outlets: { content: 'service/project/create' }}]);
	}

	goDetail($event: any) {
		const project = $event.element.getData();

		this.router.navigate(['/main', { outlets: { content: 'service/project/detail/' + project.id + '/' }}]);
	}
}
